import API from "../axiosConfig";

export const getDuplicatedVehicles = async () => {
  try {
    const response = await API.get("/vehicles/duplicates");
    return response.data;
  } catch (error) {
    console.error("Error fetching duplicated vehicles:", error);
    throw error;
  }
};

export const mergeDuplicatedVehicles = async (payload) => {
  try {
    const response = await API.post("/vehicles/duplicates/merge", payload);
    return response.data;
  } catch (error) {
    console.error("Error merging duplicated vehicles:", error);
    throw error;
  }
};
